import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M12 24A12 12 0 1 0 0 12a12 12 0 0 0 12 12M7.5 9A1.5 1.5 0 0 1 9 7.5h6A1.5 1.5 0 0 1 16.5 9v6a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 15Z"
    }, null, -1)
  ]));
}
const entertainmentControlButtonCircleStopSquare = { render };
export {
  entertainmentControlButtonCircleStopSquare as default,
  render
};
//# sourceMappingURL=entertainment-control-button-circle-stop-square.svg.js.map
